import {useState} from 'react';
import classNames from 'classnames';
import { KeyboardSvg } from '../../Svg';
import style from './index.module.less';

export default function KeyboardTip() {
  const [showAlert, setShowAlert] = useState(false);

  return <div>
    <div className={style.keyboardBox}>
      <button data-disable className={classNames(style.keyboard, showAlert ? style.active : '')} onClick={()=> {setShowAlert(!showAlert);}}>{KeyboardSvg({className: style.svgIcon})}Help</button>
    </div>
    {showAlert ? 
      <div className={style.alert} data-disable>Use TAB to navigate between the draggable elements. The active element can be moved between open gaps using the arrow keys. Your answer is saved continuously.</div>
      : null
    }
  </div>;
}